/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { listReportUrls } from '../fn/reporting-report-url/list-report-urls';
import { ListReportUrls$Params } from '../fn/reporting-report-url/list-report-urls';
import { ReportUrl } from '../models/report-url';

@Injectable({ providedIn: 'root' })
export class ReportingReportUrlService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reportUrlControllerListReportUrls()` */
  static readonly ReportUrlControllerListReportUrlsPath = '/reporting/report-url';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listReportUrls()` instead.
   *
   * This method doesn't expect any request body.
   */
  listReportUrls$Response(
    params?: ListReportUrls$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<ReportUrl>>> {
    return listReportUrls(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listReportUrls$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listReportUrls(params?: ListReportUrls$Params, context?: HttpContext): Observable<Array<ReportUrl>> {
    return this.listReportUrls$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReportUrl>>): Array<ReportUrl> => r.body)
    );
  }
}
